import { Badge, CardGrid, EmptyState, StoreCard } from '@beautyburst/ui';
import { AVAILABILITY_LABEL_TEXT } from '@beautyburst/types';
import { semanticColor, space, typeStyle } from '@beautyburst/tokens';
import { customerHref } from '../base-path.ts';
import type { AvailabilityResult } from '@beautyburst/customer';

export interface NearbyStore {
  slug: string;
  name: string;
  tagline: string | null;
  heroMediaKey: string | null;
  averageRating: number | null;
  reviewCount: number;
  distanceMiles: number | null;
  pickupEnabled: boolean;
  deliveryEnabled: boolean;
  availability: AvailabilityResult | null;
}
export function StoresScreen({
  stores,
  mediaUrlFor,
}: {
  stores: readonly NearbyStore[];
  mediaUrlFor?: (mediaKey: string) => string | null;
}) {
  return (
    <section aria-labelledby="stores-heading" style={{ display: 'grid', gap: space[5] }}>
      <h1
        id="stores-heading"
        style={{ ...typeStyle('headingLg'), color: semanticColor.textPrimary, margin: 0 }}
      >
        Stores near you
      </h1>
      {stores.length === 0 ? (
        <section aria-labelledby="stores-status-title">
          <h2
            id="stores-status-title"
            style={{ ...typeStyle('headingSm'), color: semanticColor.textPrimary }}
          >
            Store availability
          </h2>
          <EmptyState
            title="No stores in your area yet"
            description="Beauty Burst is not yet available in your area, or no participating stores are currently available."
            action={<a href={customerHref('/categories')}>Browse beauty categories</a>}
          />
        </section>
      ) : (
        <CardGrid label="Nearby stores">
          <>
            {stores.map((store) => (
              <li key={store.slug}>
                <StoreCard
                  href={customerHref(`/stores/${store.slug}`)}
                  storeName={store.name}
                  bannerUrl={
                    store.heroMediaKey === null || mediaUrlFor === undefined
                      ? null
                      : mediaUrlFor(store.heroMediaKey)
                  }
                  tagline={store.tagline}
                  averageRating={store.averageRating}
                  reviewCount={store.reviewCount}
                  distanceMiles={store.distanceMiles}
                  pickupEnabled={store.pickupEnabled}
                  deliveryEnabled={store.deliveryEnabled}
                />
                {store.availability === null ? null : (
                  <Badge variant="info">{AVAILABILITY_LABEL_TEXT[store.availability.label]}</Badge>
                )}
              </li>
            ))}
          </>
        </CardGrid>
      )}
    </section>
  );
}
